<template>
  <!-- 注意这里的src如果为undefined，不会触发加载，也不会产生error事件 -->
  <img :src="src || ' '" v-on:error="handleError"/>
</template>

<script>

  export default {
    name: 'SimpleImage',
    props: ['src', 'placeholder'],
    data () {
      return {
        shouldHandleError: true, // 是否需要处理Error
      }
    },
    watch: {
      src: function () { // src发生变化时重新监听Error
        this.shouldHandleError = true
      }
    },
    methods: {
      handleError (event) {
        console.log('handleError', this, event)
        if (this.shouldHandleError) {
          this.shouldHandleError = false
          event.target.src = this.placeholder || require('../static/logo.png')
        }
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/widgets/SimpleImage.vue